// extracted by mini-css-extract-plugin
module.exports = {"more_button":"ReadMore__more_button___Z0QoI"};